import { render, staticRenderFns } from "./statsList.vue?vue&type=template&id=a71838e0&scoped=true&"
import script from "./statsList.vue?vue&type=script&lang=js&"
export * from "./statsList.vue?vue&type=script&lang=js&"
import style0 from "./statsList.vue?vue&type=style&index=0&id=a71838e0&prod&lang=scss&"
import style1 from "./statsList.vue?vue&type=style&index=1&id=a71838e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71838e0",
  null
  
)

export default component.exports